import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let Loader = class Loader extends Vue {
    destroyLoaders() {
        this.$data.loaderArray = [];
    }
    showLoader(obj) {
        if (obj.message === null) {
            for (let i = 0; i < this.$data.loaderArray.length; i++) {
                if (this.$data.loaderArray[i].id === obj.idstring) {
                    this.$data.loaderArray.splice(i, 1);
                }
            }
        }
        else {
            this.$data.loaderArray.push({ message: obj.message, id: obj.idstring });
        }
    }
};
Loader = __decorate([
    Component({
        data() {
            return {
                visible: false,
                loaderMessage: '',
                loaderArray: [],
            };
        },
        created() {
            // set a event to detect when a load has triggered
            window.eventBus.$on('showLoader', (obj) => {
                this.showLoader(obj);
            });
            window.eventBus.$on('destroyAllLoaders', this.destroyLoaders);
        },
        beforeDestroy() {
            //(window as any).eventBus.$off('showLoader');
            //(window as any).eventBus.$off('hideLoader');
            //(window as any).eventBus.$off('destroyAllLoaders');
        },
    })
], Loader);
export default Loader;
